import { render, staticRenderFns } from "./CartProductCard.vue?vue&type=template&id=30e4462f&scoped=true&"
import script from "./CartProductCard.vue?vue&type=script&lang=js&"
export * from "./CartProductCard.vue?vue&type=script&lang=js&"
import style0 from "./CartProductCard.vue?vue&type=style&index=0&id=30e4462f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e4462f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiNumberInput: require('/app/components/UI/UiNumberInput.vue').default,UiButton: require('/app/components/UI/UiButton.vue').default})
